import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_RESTAURANT_DATA_FULFILLED: (state, action) => ({
			...state,
			data: action.payload.data,
		}),
	},
	{
		data: [],
	},
);



// WEBPACK FOOTER //
// ./src/reducers/restaurant.js